import React from 'react';

import './style.scss';

interface propsInterface {
  items: string[];
}

const Breadcrumbs = ({ items }: propsInterface) => {
  return (
    <div className='v-breadcrumbs'>
      {items.map(item => item && <span key={item}>{item}</span>)}
    </div>
  );
}

export default Breadcrumbs;